import React, { useEffect, useState } from "react";
import { Formik, Form, Field, ErrorMessage } from "formik";
import { Link, useNavigate } from "react-router-dom";
import * as Yup from "yup";
import {
  isUserExist,
  register,
  counsellorRegistration,
  checkCounsellorEmail,
} from "../api/api";
import "../CounsellorAllPages/CounsellorRegistration.css";
import { environment } from "../../environments/environments";
import AvailableSelector from "./AvailabilitySelector";
import { v4 as uuidv4 } from "uuid";

const CounsellorRegistration = () => {
  const navigate = useNavigate();
  const [jwtsToken, setjwtsToken] = useState("");
  const [deviceToken, setDeviceToken] = useState("");
  const [isLoading, setIsLoading] = useState(false);
  const [availabilityModalVisible, setAvailabilityModalVisible] =
    useState(false);
  const [available, setAvailable] = useState([]);

  useEffect(() => {
    const generatedToken = uuidv4().replace(/-/g, "").substring(0, 32);
    console.log("Generated Token in RegisterPage:", generatedToken);

    // Save to localStorage
    localStorage.setItem("jwtToken", generatedToken);

    // Update state
    setjwtsToken(generatedToken);
  }, []);
  useEffect(() => {
    console.log("Initializing OneSignal...");
    window.OneSignalDeferred = window.OneSignalDeferred || [];
    window.OneSignalDeferred.push(async function (OneSignal) {
      try {
        console.log("OneSignal object inside Deferred:", OneSignal);

        await OneSignal.init({
          // appId: environment.onesignalAppId,
          appId: "27fa0429-65d5-4544-b14c-2ad57e859071",
          notifyButton: {
            enable: true,
          },
        });

        console.log("OneSignal initialized");

        const isPushEnabled = await OneSignal.isPushNotificationsEnabled();
        console.log("Is push enabled:", isPushEnabled);

        if (!isPushEnabled) {
          console.warn("Push is not enabled. Prompting user...");
          await OneSignal.showSlidedownPrompt();
        }

        const subId = await OneSignal.getUserId();
        console.log("subId", subId);

        if (subId) {
          setDeviceToken(subId);
        } else {
          console.warn("User not subscribed to push.");
        }
      } catch (err) {
        console.error("OneSignal init failed:", err);
      }
    });
  }, []);

  const validationSchema = Yup.object({
    name: Yup.string().required("Name is required"),
    email: Yup.string()
      .email("Invalid email format")
      .required("Email is required"),
    role: Yup.string().required("Please select a role"),
    dob: Yup.date().required("Date of Birth is required"),
    phoneNumber: Yup.string()
      .matches(/^\d{5,13}$/, "Phone number must be 5 or 13 digits")
      .required("Phone Number is required"),
    password: Yup.string()
      .min(6, "Password must be at least 6 characters")
      .required("Password is required"),
    confirmPassword: Yup.string()
      .oneOf([Yup.ref("password"), null], "Passwords must match")
      .required("Confirm Password is required"),
    available: Yup.array()
      .of(
        Yup.object().shape({
          day: Yup.string().required("Day is required"),
          start: Yup.string().required("Start time is required"),
          till: Yup.string().required("Till time is required"),
          off_day: Yup.string()
            .oneOf(["0", "1"])
            .required("Off day is required"),
        })
      )
      .min(1, "Availability is required")
      .required("Availability is required"),
    acceptTerms: Yup.bool().oneOf(
      [true],
      "You must accept the Terms and Conditions"
    ),
  });

  const handleCustomChange = async (value, setFieldValue, setFieldError) => {
    setFieldValue("email", value.toLowerCase());
    try {
      const response = await checkCounsellorEmail({
        email: value.toLowerCase(),
      });
      if (response?.success === false) {
        setFieldError("email", response.message);
      } else {
        setFieldError("email", "");
      }
    } catch (error) {
      console.error("Error checking email:", error);
    }
  };

  const handleSubmit = async (values) => {
    console.log("Form Values:", values);
    setIsLoading(true);
    try {
      const registerFormData = { ...values };
      console.log("values_registration_form", registerFormData);
      const firstPaymentResponse = await counsellorRegistration(
        registerFormData
      );
      console.log("registration", firstPaymentResponse);
      if (firstPaymentResponse?.data) {
        localStorage.setItem(
          "currentUser",
          JSON.stringify(firstPaymentResponse?.data)
        );
      }
      if (
        firstPaymentResponse?.data?.profile_completion_status ===
        "emailvarification"
      ) {
        alert("Success: " + firstPaymentResponse?.message);
        navigate("/CounsellorEmailVerification", {
          state: { email: values.email },
        });
      } else {
        const emailErrors = firstPaymentResponse?.message?.email;
        const errorMessage = emailErrors
          ? emailErrors.join("\n")
          : "Something went wrong";
        alert(errorMessage);
      }
    } catch (error) {
      alert("Error: Something went wrongh");
      console.error("Submit error:", error);
    } finally {
      setIsLoading(false);
    }
  };

  return (
    <div className="registration-container">
      <div className="registration-box">
        <h1>Counsellor Register</h1>

        <Formik
          enableReinitialize
          initialValues={{
            name: "",
            email: "",
            dob: "",
            phoneNumber: "",
            password: "",
            confirmPassword: "",
            acceptTerms: false,
            address: "",
            role: "",
            postcode: "",
            bio: "",
            available: [],
            token: deviceToken || "",
            profile_completion_status: "emailvarification",
            jwtsecret: jwtsToken,
            registering_from: "web",
          }}
          validationSchema={validationSchema}
          onSubmit={handleSubmit}
        >
          {({
            isSubmitting,
            errors,
            touched,
            handleChange,
            values,
            setFieldValue,
          }) => (
            <Form className="registration-form">
              <div className="registerform-group">
                <div className="labelDiv">
                  <label>Name</label>
                </div>
                <Field
                  type="text"
                  name="name"
                  className="form-input"
                  // placeholder="Enter your name"
                />
              </div>
              <ErrorMessage
                name="name"
                component="div"
                className="error-message"
              />
              <div className="registerform-group">
                <div className="labelDiv">
                  <label>Email</label>
                </div>
                <Field name="email">
                  {({ field, form }) => (
                    <input
                      {...field}
                      type="email"
                      className="form-input"
                      // placeholder="Enter your email"
                      onChange={(e) =>
                        handleCustomChange(
                          e.target.value,
                          form.setFieldValue,
                          form.setFieldError
                        )
                      }
                    />
                  )}
                </Field>
              </div>
              <ErrorMessage
                name="email"
                component="div"
                className="error-message"
              />
              <div className="registerform-group">
                <div className="labelDiv">
                  <label>Date of Birth</label>
                </div>
                <Field type="date" name="dob" className="form-input" />
              </div>
              <ErrorMessage
                name="dob"
                component="div"
                className="error-message"
              />
              <div className="registerform-group">
                <div className="labelDiv">
                  <label>Phone Number</label>
                </div>
                {/* <Field
                  type="tel"
                  name="phoneNumber"
                  className="form-input"
                  // placeholder="Enter your Phone Number"
                /> */}

                {/* </div> */}
                <Field
                  type="tel"
                  name="phoneNumber"
                  className="form-input"
                  // maxLength={11}
                  placeholder="Enter your phone number"
                />
              </div>
              <ErrorMessage
                name="phoneNumber"
                component="div"
                className="error-message"
              />
              <div className="registerform-group">
                <div className="labelDiv">
                  <label>Password</label>
                </div>
                <Field
                  type="password"
                  name="password"
                  className="form-input"
                  // placeholder="Enter your password"
                />
              </div>
              <ErrorMessage
                name="password"
                component="div"
                className="error-message"
              />
              <div className="registerform-group">
                <div className="labelDiv">
                  <label>Confirm Password</label>
                </div>
                <div>
                  <Field
                    type="password"
                    name="confirmPassword"
                    className="form-input"
                    // placeholder="Confirm your password"
                  />
                </div>
              </div>
              <ErrorMessage
                name="confirmPassword"
                component="div"
                className="error-message"
              />
              {/* Role */}
              <div className="role-picker">
                <select
                  className="inside-role-picker"
                  name="role"
                  value={values.role}
                  onChange={handleChange}
                >
                  <option value="">Select Role...</option>
                  <option value="connection_curator">Connection Curator</option>
                  <option value="match_making_consultant">
                    Match Making Consultant
                  </option>
                  <option value="relationship_success_coach">
                    Relationship Success Coach
                  </option>
                  <option value="match_success_advisor">
                    Match Success Advisor
                  </option>
                </select>
                {errors.role && touched.role && (
                  <div className="error">{errors.role}</div>
                )}
              </div>
              {/* <ErrorMessage
                name="confirmPassword"
                component="div"
                className="error-message"
              /> */}
              <div className="registerform-group">
                <div className="labelDiv">
                  <label>Address</label>
                </div>
                <Field type="text" name="address" className="form-input" />
              </div>
              <div className="registerform-group">
                <div className="labelDiv">
                  <label>PostCode</label>
                </div>
                <Field type="text" name="postcode" className="form-input" />
              </div>
              {/* <div className="registerform-group"> */}

              {/* </div> */}
              <div className="registerform-group">
                <textarea
                  name="bio"
                  placeholder="Type Your Bio (Optional)"
                  rows={4}
                  value={values.bio}
                  onChange={handleChange}
                />
              </div>
              <div className="labelDiv">
                <label>Available</label>
              </div>
              <div
                className="registerform-group-avaiability"
                onClick={() => setAvailabilityModalVisible(true)}
              >
                <p className="setavailability">
                  {values?.available?.length > 0
                    ? "Availability Set"
                    : "Set Availability"}
                </p>
              </div>
              <AvailableSelector
                visible={availabilityModalVisible}
                onClose={() => setAvailabilityModalVisible(false)}
                initialValues={available}
                onSave={(selected) => {
                  setAvailable(selected);
                  setFieldValue("available", selected);
                  setAvailabilityModalVisible(false);
                }}
              />

              <div className="termform-group">
                <Field
                  type="checkbox"
                  name="acceptTerms"
                  className="form-checkbox"
                />
                <label>
                  <label>
                    I accept the{" "}
                    <Link
                      to="/termsandcondition"
                      style={{ color: "#058787", textDecoration: "none" }}
                    >
                      Terms and Conditions {" / "}
                    </Link>
                    <Link
                      to="/privacypolicy"
                      style={{ color: "#058787", textDecoration: "none" }}
                    >
                      Privacy policy
                    </Link>
                  </label>
                </label>
              </div>
              <ErrorMessage
                name="acceptTerms"
                component="div"
                className="termserror-message"
              />
              <button
                type="submit"
                className="register-button"
                disabled={isSubmitting || isLoading}
              >
                {isLoading ? "Registering..." : "Register"}
              </button>
              <button
                type="submit"
                className="counsellor-register-button"
                onClick={() => navigate("/Login")}
              >
                User Register
              </button>
            </Form>
          )}
        </Formik>

        {/* <div className="login-redirect">
          <p>
            Already have an account?{" "}
            <span className="login-link" onClick={() => navigate("/")}>
              Login
            </span>
          </p>
        </div> */}
      </div>
    </div>
  );
};

export default CounsellorRegistration;
